import script from "./SliderAccessories.vue?vue&type=script&setup=true&lang=js"
export * from "./SliderAccessories.vue?vue&type=script&setup=true&lang=js"

import "./SliderAccessories.vue?vue&type=style&index=0&id=42eedf51&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42eedf51"]])

export default __exports__